import skokka from "./skokka";
import axios from "axios";

const SkokkaPlugin = (function () {
  function install(vue) {
    vue.prototype.$skokka = skokka;

    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

    vue.prototype.$http = axios;

    if (typeof window !== "undefined") {
      window.$skokka = skokka;
      window.$http = axios;
    }
  }

  return { install };
})();

export default SkokkaPlugin;
